import React from "react";
import Projects from "../components/projects/Projects";
import exampleImage from "../assets/construction.png";
function ProjectsPage() {
  return <Projects />;
}

export default ProjectsPage;
